import { jsx } from 'react/jsx-runtime';
import 'react';
import Box from '../../../Base/Layouts/Box/Box.js';
import 'tailwind-merge';
import '../../../Base/Layouts/FullBleed/FullBleed.js';

const NewCircle = ()=>{
    return /*#__PURE__*/ jsx(Box, {
        className: "size-3.5 rounded-full bg-gradient-primary-90",
        "data-testid": "imageLabel-newCircle",
        children: /*#__PURE__*/ jsx("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ jsx("path", {
                d: "M9.6499 10H8.50732L5.7124 5.95703H5.66406V10H4.3457V3.63672H5.50586L8.27881 7.67529H8.33594V3.63672H9.6499V10Z",
                fill: "white"
            })
        })
    });
};

export { NewCircle as default };
